import { useQuery } from "@apollo/client";
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useParams } from "react-router";

import { CapsuleFormComplete } from "./CapsuleFormComplete";
import { Capsule, GET_CAPSULE } from "./CapsulePage";

export const CapsuleEditCompletePage = () => {
  const { capsuleId } = useParams<{ capsuleId: string }>();

  const query = useQuery<{ capsules: Capsule[] }>(GET_CAPSULE, {
    variables: { capsuleId },
  });

  const capsule = query.data?.capsules?.[0];
  if (!capsule) return null;

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              defaultHref={`/main/wardrobe/capsules/${capsuleId}/edit`}
            />
          </IonButtons>
          <IonTitle>Edit capsule</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <CapsuleFormComplete capsule={capsule} />
      </IonContent>
    </IonPage>
  );
};
